<template>
  <div class="row dash_filter" style="display: flex; align-items: center">
    <div class="form-group text-left season_year_select col-3" style="margin-right: 20px">
      <DxSelectBox
        v-model="local_season_uuid"
        :data-source="seasons"
        display-expr="name"
        value-expr="uuid"
        :on-value-changed="onSeasonChanged"
        placeholder=""
      />
    </div>

    <div class="form-group text-left season_year_select col-3" style="margin-right: 20px">
      <DxTagBox
        v-model="selected_groups"
        :data-source="groups"
        display-expr="name"
        value-expr="uuid"
        :show-clear-button="true"
        :search-enabled="true"
        :placeholder="$t('common.select_group')"
        @value-changed="onGroupsChanged"
      />
    </div>

    <div class="form-group text-right department_select col-6">
      <DxTagBox
        v-model="selected_departments"
        :data-source="departments"
        display-expr="name"
        value-expr="uuid"
        :show-clear-button="true"
        :search-enabled="true"
        :placeholder="$t('common.select_department')"
        @value-changed="onDepartmentsChanged"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { DxSelectBox } from "devextreme-vue/select-box";
import { DxTagBox } from "devextreme-vue/tag-box";

export default {
  name: "DashFilters",
  components: {
    DxSelectBox,
    DxTagBox,
  },
  data() {
    return {
      local_season_uuid: null,
      selected_departments: [],
      selected_groups: [],
    };
  },
  watch: {
    seasons: {
      handler: function (newVal) {
        if (newVal.length > 0) {
          this.local_season_uuid = this.seasons[0].uuid;
          this.loadGroups();
          this.emitFilterChanged();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      seasons: "seasons/seasons",
      departments: "company/departments",
      groups: "works-parcels/parcelGroups",
    }),
  },
  methods: {
    ...mapActions({
      getGroups: "works-parcels/getParcelGroups",
    }),
    onSeasonChanged(e) {
      this.local_season_uuid = e.value;
      this.emitFilterChanged();
      this.loadGroups();
    },
    onDepartmentsChanged(e) {
      this.selected_departments = e.value;
      this.emitFilterChanged();
    },
    onGroupsChanged(e) {
      this.selected_groups = e.value;
      this.emitFilterChanged();
    },
    emitFilterChanged() {
      this.$emit("filter-changed", {
        season_uuid: this.local_season_uuid,
        departments: this.selected_departments,
        groups: this.selected_groups,
      });
    },
    loadGroups() {
      this.selected_groups = [];
      if (!this.local_season_uuid) return;
      this.getGroups({
        season_uuid: this.local_season_uuid,
      });
    },
  },
  mounted() {
    if (this.seasons?.length > 0 && !this.local_season_uuid) {
      this.local_season_uuid = this.seasons[0].uuid;
      this.loadGroups();
      this.emitFilterChanged();
    }
  },
};
</script>
<style scoped>
.season_year_select {
  width: 250px;
  margin-left: 15px;
}

.department_select {
  margin-left: 15px;
}

.dash_filter {
  margin-top: 20px;
  margin-bottom: 25px;
}
</style>
